var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tabsContent[_vm.active].name,{tag:"components"})
}
var staticRenderFns = []

export { render, staticRenderFns }